<template>
  <el-menu class="navbar" mode="horizontal">
    <hamburger
      class="hamburger-container"
      :toggleClick="toggleSideBar"
      :isActive="sidebar.opened"
    ></hamburger>
    <breadcrumb></breadcrumb>
    <el-dropdown class="avatar-container" trigger="click">
      <div class="avatar-wrapper">
        <img class="user-avatar" :src="img_home_setting" />
        <!-- <i class="el-icon-caret-bottom"></i> -->
      </div>
      <el-dropdown-menu class="user-dropdown" slot="dropdown">
        <!-- <router-link class="inlineBlock" to="/">
          <el-dropdown-item>
            首页
          </el-dropdown-item>
        </router-link> -->
        <el-dropdown-item>
          <span @click="updatePassword" style="display:block;">修改密码</span>
        </el-dropdown-item>
        <el-dropdown-item divided>
          <span @click="logout" style="display:block;">退出</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-dialog
      title="修改密码"
      append-to-body=""
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="30%"
    >
      <el-form
        autoComplete="on"
        :model="loginForm"
        :rules="loginRules"
        ref="loginForm"
        label-position="left"
      >
        <el-form-item prop="password" label="旧密码">
          <el-input
            name="oldPassword"
            :type="oldPwdType"
            v-model="loginForm.oldPassword"
            autoComplete="on"
            placeholder="请输入旧密码"
          >
            <span slot="prefix">
              <svg-icon icon-class="password" class="color-main"></svg-icon>
            </span>
            <span slot="suffix" @click="showOldPwd">
              <svg-icon icon-class="eye" class="color-main"></svg-icon>
            </span>
          </el-input>
        </el-form-item>
        <el-form-item prop="prop_new_password" label="新密码">
          <el-input
            name="newPassword"
            :type="newPwdType"
            v-model="loginForm.newPassword"
            placeholder="请输入新密码"
          >
            <span slot="prefix">
              <svg-icon icon-class="password" class="color-main"></svg-icon>
            </span>
            <span slot="suffix" @click="showNewPwd">
              <svg-icon icon-class="eye" class="color-main"></svg-icon>
            </span>
          </el-input>
          <div style="height: 10px;"></div>
          <el-input
            name="newPassword2"
            :type="newPwdType"
            v-model="loginForm.newPassword2"
            placeholder="请再次输入新密码"
          >
            <span slot="prefix">
              <svg-icon icon-class="password" class="color-main"></svg-icon>
            </span>
            <span slot="suffix" @click="showNewPwd">
              <svg-icon icon-class="eye" class="color-main"></svg-icon>
            </span>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleUpdatePasswordConfirm"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </el-menu>
</template>

<script>
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
import { updatePassword } from "@/api/login";
import img_home_setting from '@/assets/images/ic_home_setting.png';

export default {
  data() {
    let loginForm = {
      oldPassword: "",
      newPassword: "",
      newPassword2: ""
    };
    const validatePass = (rule, value, callback) => {
      const oldPassword = loginForm.oldPassword;
      if (oldPassword.length < 3) {
        callback(new Error("密码不能小于3位"));
      } else {
        callback();
      }
    };
    const validatePass2 = (rule, value, callback) => {
      const { newPassword, newPassword2 } = loginForm;
      if (newPassword != newPassword2) {
        callback(new Error("两次输入的新密码不一致"));
      } else if (newPassword.length < 3 || newPassword2.length < 3) {
        callback(new Error("密码不能小于3位"));
      } else {
        callback();
      }
    };
    return {
      img_home_setting,
      loginForm: loginForm,
      loginRules: {
        password: [
          { required: true, trigger: "blur", validator: validatePass }
        ],
        prop_new_password: [
          { required: true, trigger: "blur", validator: validatePass2 }
        ]
      },
      oldPwdType: "password",
      newPwdType: "password",
      dialogVisible: false
    };
  },
  components: {
    Breadcrumb,
    Hamburger
  },
  computed: {
    ...mapGetters(["sidebar", "avatar"])
  },
  methods: {
    showOldPwd() {
      if (this.oldPwdType === "password") {
        this.oldPwdType = "";
      } else {
        this.oldPwdType = "password";
      }
    },
    showNewPwd() {
      if (this.newPwdType === "password") {
        this.newPwdType = "";
      } else {
        this.newPwdType = "password";
      }
    },
    toggleSideBar() {
      this.$store.dispatch("ToggleSideBar");
    },
    updatePassword() {
      this.dialogVisible = true;
    },
    logout() {
      this.$store.dispatch("LogOut").then(() => {
        location.reload(); // 为了重新实例化vue-router对象 避免bug
      });
    },
    async handleUpdatePasswordConfirm() {
      try {
        const data = {
          newPassword: this.loginForm.newPassword,
          oldPassword: this.loginForm.oldPassword
        };
        let response = await updatePassword(data);
        response = await this.$store.dispatch("LogOut");
        this.dialogVisible = false;
        this.$message({
          type: "success",
          message: "修改密码成功，请重新登录！"
        });
        this.$nextTick(() => {
          location.reload();
        });
      } catch (error) {
        this.$message("修改密码出现异常，请稍后重试！");
      }
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;

  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }

  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }

  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 10px;

    .avatar-wrapper {
      cursor: pointer;
      margin-top: 0px;
      position: relative;

      .user-avatar {
        width: 30px;
        height: 30px;
        margin-top: 5px;
        border-radius: 10px;
      }

      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue